import { axiosWdw, domainEndpoint } from './axios';

export default {
  searchAddress(searchText: string) {
    return new Promise((resolve, reject) => {
      axiosWdw({
        method: 'GET',
        url: domainEndpoint() + '/search_address',
        params: { q: searchText },
      })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  getRegistrationConfig() {
    return new Promise((resolve, reject) => {
      axiosWdw({
        method: 'GET',
        url: domainEndpoint() + '/register_config',
      })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  postRegister(regData: any) {
    return new Promise((resolve, reject) => {
      axiosWdw({
        method: 'POST',
        url: domainEndpoint() + '/register',
        data: regData,
      })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  getDomainConfig() {
    return axiosWdw({
      method: 'GET',
      url: domainEndpoint(),
      params: { fieldset: 'config' },
    })
      .then(response => {
        if (response && response.data.success) {
          return response.data.data;
        }
      })
      .catch(error => {
        console.log(error);
      });
  },

  getDiscussConfig() {
    return axiosWdw({
      method: 'GET',
      url: domainEndpoint() + '/discuss',
    })
      .then(response => {
        if (response && response.data.success) {
          return response.data.data;
        } else {
          console.log('error');
        }
      })
      .catch(error => {
        console.log(error);
      });
  },

  postRefetchCaptcha() {
    return axiosWdw({
      method: 'POST',
      url: domainEndpoint() + '/refetch_captcha',
    })
      .then(response => {
        if (response && response.data.success) {
          return response.data.data;
        } else {
          console.log('error');
        }
      })
      .catch(error => {
        console.log(error);
      });
  },
};
